module.exports = __webpack_public_path__ + "static/media/uwmedicine.4d224420.png";